<template>
  <v-layout row wrap>
    <v-flex xs11>
      <v-text-field
          v-model="label.name"
          :label="'app.name' | trans"
          :rules="rules.name"
          @input="updateLabel"
      >
          <template v-slot:append-outer>
              <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-width="200"
                      offset-x
              >
                  <template v-slot:activator="{ on }">
                      <div
                          :class="`color-box ${label.color} pointer`"
                          v-on="on"
                      ></div>
                  </template>

                  <v-card>
                      <v-card-text>
                          <v-layout row wrap>
                              <v-flex xs4 v-for="color in colors" :key="color.value">
                                  <div
                                    :class="`color-box-bigger ${color.value} my-1  mx-auto pointer`"
                                    @click="setColor(color)"
                                  ></div>
                              </v-flex>
                          </v-layout>
                      </v-card-text>

                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" flat @click="menu = false">Zamknij</v-btn>
                      </v-card-actions>
                  </v-card>
              </v-menu>
          </template>
      </v-text-field>
    </v-flex>
    <v-flex xs1>
      <icon-button
          icon="delete"
          color="red"
          cls="mt11"
          @click="deleteLabel"
      >
        {{ 'app.delete' | trans }}
      </icon-button>
    </v-flex>
  </v-layout>
</template>

<script>
import {trans} from "../../app";
import RulesBuilder from "../../utils/rulesBuilder";

export default {
  data: function () {
    return {
      rulesBuilder: new RulesBuilder(),
      menu: false,
      label: {
        id: null,
        name: '',
        color: '',
      },
      colors: [
        {
          value: 'yellow',
          name: trans('app.calendar.colors.yellow'),
        },
        {
          value: 'orange',
          name: trans('app.calendar.colors.orange'),
        },
        {
          value: 'red',
          name: trans('app.calendar.colors.red'),
        },
        {
          value: 'violet',
          name: trans('app.calendar.colors.violet'),
        },
        {
          value: 'blue',
          name: trans('app.calendar.colors.blue'),
        },
        {
          value: 'green',
          name: trans('app.calendar.colors.green'),
        },
      ],
    };
  },
  props: {
    id: [Number, String],
    name: String,
    color: String
  },
  mounted() {
    this.label.id = this.id;
    this.label.name = this.name;
    this.label.color = this.color;
  },
  methods: {
    deleteLabel() {
      this.$emit('deleteLabel', {label: {...this.label}});
    },
    updateLabel() {
      this.$emit('updateLabel', {label: {...this.label}});
    },
    setColor(color) {
        this.label.color = color.value;
        this.menu = false;
        this.$emit('updateLabel', {label: {...this.label}});
    },
  },
  computed: {
    rules: function () {
      return {
        name: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.name'))
              .addMinLengthRule(trans('app.name'), 1)
              .addMaxLengthRule(trans('app.name'), 255)
              .getRules(),
        ],
      };
    },
  },
}
</script>

<style scoped>
  .color-box {
    width: 20px;
    height: 20px;
    border-radius: 3px;
  }

  .color-box-bigger {
      width: 30px;
      height: 30px;
      border-radius: 3px;
  }

  .color-box-bigger:hover {
      border: 1px solid #210000 !important;
  }

  .yellow {
    background: #f6bf26 !important;
  }

  .orange {
    background: #f4511e !important;
  }

  .red {
    background: #d50000 !important;
  }

  .violet {
    background: #7986cb !important;
  }

  .blue {
    background: #039be5 !important;
  }

  .green {
    background: #4caf50 !important;
  }

  .mt11 {
    margin-top: 11px;
  }

  .pointer {
      cursor: pointer;
  }
</style>
